export default __webpack_public_path__ + "static/avatar-old-0722008343582cab82e48440462ca35a.jpg";